import React, { lazy, useEffect, useState } from "react";
import "../../common/index.scss";
import {
  setFilteredItem,
  setFilteredDates,
  setFilteredIDs,
  clearFilters,
  getInventorySearchCriteria,
} from "../../../reducers/search";
import { checkForStringValue } from "../../../utils/check-filter-for-value";
import {
  getUpcomingAuctionsPreview,
  getRecentItems,
  getAuctionBlock,
} from "../../../reducers/main";
import { getWatchList } from "../../../reducers/watchlist";
import {
  getUpcomingEventsSorted,
  getTodaysEvents,
  loadingTodaysEvents,
  registerForAuctions,
  validateTermsAcceptanceByEventId,
} from "../../../reducers/events";
import { getUserInformation, getBlackFlagStatus, getContactInfo } from "../../../reducers/account";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { checkForLiveAuction } from "../../../utils/check-for-live-auction";
import { Container } from "reactstrap";
import RecentlyViewed from "./recently-viewed";
import checkForCriteriaKeys from "../../../utils/check-for-criteria-keys";
import handlePathChoice from "../../../utils/handle-path-choice";
import LiveAuctionBanner from "./live-auction-banner";
import { updateRegisterState } from "../../../reducers/register";
import TodaysEvents from "./todays-events.js";
import { Row, Col, Button } from "reactstrap";
import ConfirmationModal from "../../common/modal/confirmation-modal";
import RegisterForm from "../../account/login";
import RegisterCompleteModal from "../../common/modal";
import { updateUserTermsAcceptance } from "../../../reducers/auction";
import { updateTermsAcceptance } from "../../../reducers/account";
import Modal from "../../common/modal";
import { OnlineBiddingStatus } from "../../../constants/online-bidding-status";
import OnlineBiddingRegistrationModal from "../../common/modal/online-bidding-registration-modal";
import CommonModal from "../../common/modal/common-modal";
import AccountSelectionModal from "./registration/accountSelectionModal";

const Tabs = lazy(() => import("../../common/tabs"));
const UpcommingAuctions = lazy(() => import("./upcoming-auctions"));
const Cta = lazy(() => import("./cta"));
const LoginRegister = lazy(() => import("../../account/login"));

const Home = (props) => {
  const {
    getRecentItems,
    getUpcomingAuctionsPreview,
    getWatchList,
    isSignedIn,
    upcoming,
    push,
    loaded_upcoming,
    recentlyViewed,
    getAuctionBlock,
    auctionBlock,
    setFilteredDates,
    setFilteredIDs,
    clearFilters,
    getInventorySearchCriteria,
    checkForCriteriaKeys,
    handlePathChoice,
    getUserInformation,
    getUpcomingEventsSorted,
    content,
    location,
    updateRegisterState,
    getTodaysEvents,
    todaysEventsLoaded,
    loadingTodaysEvents,
    todaysEvents,
    registerForAuctions,
    validateTermsAcceptanceByEventId,
    hasAccount,
    updateUserTermsAcceptance,
    updateTermsAcceptance,
    passwordRequest,
    isGuest,
    retailMode,
    onlineBiddingStatus_ID,
    getBlackFlagStatus,
    getContactInfo,
    user_ID,
    enableOnlineAuction,
  } = props;

  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [loginModalOpen, setLoginModal] = useState(false);
  const [termsAndConditionsDocument, setTermsAndConditionsDocument] = useState(
    ""
  );
  const [showTermsAcceptanceModal, toggleTermsAcceptanceModal] = useState(
    false
  );
  const [completeRegistrationModal, setCompleteRegistrationModal] = useState(
    false
  );
  const [selectedEvent, setSelectedEvent] = useState({});
  const [
    showBiddingRegistrationModal,
    setShowBiddingRegistrationModal,
  ] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [blackFlagError, setBlackFlagError] = useState("");
  const [showAccountSelectionModal, setShowAccountSelectionModal] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const [pendingRegistrationCallback, setPendingRegistrationCallback] = useState(null);
  const [requiresTermsAcceptance, setRequiresTermsAcceptance] = useState(false);

  const { contactInfo } = props;
  const accounts = contactInfo?.accounts ?? [];
  const hasMultipleAccounts = accounts.length > 1;

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          getUpcomingAuctionsPreview(),
          getWatchList(),
          getRecentItems(),
          getUserInformation(),
          loadingTodaysEvents(),
          getTodaysEvents(),
          getAuctionBlock(),
          getContactInfo(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    let searchParams = {};
    const search = location.search.replace("?", "").split("&");

    search.forEach((x) => {
      if (x.includes("=")) {
        let arr = x.split("=");
        searchParams = {
          ...searchParams,
          [arr[0]]: arr[1],
        };
      }
    });
    if (searchParams.code) {
      setIsPopUpOpen((prevState) => !prevState);
      updateRegisterState({
        passwordRequest: true,
      });
    }
  }, [location.search]);

  const handleRegisterForEvent = async (event, callback) => {
    if (isGuest) {
      setLoginModal(!loginModalOpen);
      return;
    }

    // Check black flag for logged-in users trying to register
    if (!event.isRegistered) {
      const isBlackFlagged = await checkBlackFlag();
      if (isBlackFlagged) {
        return;
      }
    }

    // Check if online bidding is disabled
    if (onlineBiddingStatus_ID === OnlineBiddingStatus.Disabled) {
      setShowBiddingRegistrationModal(true);
      return;
    }

    setSelectedEvent(event);
    setPendingRegistrationCallback({ fn: callback });

    const params = {
      notificationsType: {
        txtNotification: true,
        emailNotification: true,
      },
      register: !event.isRegistered,
      event_ID: event.event_ID,
      ...event,
    };

    if (!hasAccount) {
      setCompleteRegistrationModal(true);
      return;
    }

    // Unregister path — no modal needed
    if (event.isRegistered) {
      await registerForAuctions({ ...params, account_ID: null }, callback);
      return;
    }

    // Pre-check terms & conditions before showing any modal
    const termsResult = await validateTermsAcceptanceByEventId({
      event_ID: event.event_ID,
    });
    const needsTerms = !termsResult.error && !termsResult.isCurrentTermsAcceptance;
    if (needsTerms) {
      setTermsAndConditionsDocument(termsResult.termsAndConditionsDocument);
    }
    setRequiresTermsAcceptance(needsTerms);

    // Register path — multiple accounts need account selection modal
    if (hasMultipleAccounts) {
      const personalAccount = accounts.find((a) => a.isBusinessAccount === false);
      setSelectedAccountId(personalAccount ? personalAccount.account_ID : null);
      setShowAccountSelectionModal(true);
      return;
    }

    // Single account or no accounts — auto-select and register directly or show terms
    const autoAccountId = accounts.length === 1 ? accounts[0].account_ID : null;
    if (needsTerms) {
      setSelectedAccountId(autoAccountId);
      toggleTermsAcceptanceModal(true);
    } else {
      await registerForAuctions({ ...params, account_ID: autoAccountId }, callback);
    }
  };

  const handleAccountSelectionConfirm = async () => {
    setShowAccountSelectionModal(false);

    const params = {
      notificationsType: {
        txtNotification: true,
        emailNotification: true,
      },
      register: !selectedEvent.isRegistered,
      event_ID: selectedEvent.event_ID,
      account_ID: selectedAccountId,
      ...selectedEvent,
    };

    await registerForAuctions(params, pendingRegistrationCallback?.fn);
  };

  const handleAcceptTermsInModal = async () => {
    setShowAccountSelectionModal(false);
    await updateUserTermsAcceptance(
      { event_ID: selectedEvent.event_ID },
      async (result) => {
        const params = {
          notificationsType: {
            txtNotification: true,
            emailNotification: true,
          },
          register: !selectedEvent.isRegistered,
          event_ID: selectedEvent.event_ID,
          account_ID: selectedAccountId,
          ...selectedEvent,
        };
        await registerForAuctions(params, pendingRegistrationCallback?.fn);
        updateTermsAcceptance(result);
      }
    );
  };

  const handleTermsAcceptanceClick = async () => {
    await updateUserTermsAcceptance(
      { event_ID: selectedEvent.event_ID },
      async (result) => {
        toggleTermsAcceptanceModal(false);
        await registerForAuctions(
          {
            notificationsType: {
              txtNotification: true,
              emailNotification: true,
            },
            register: !selectedEvent.isRegistered,
            account_ID: selectedAccountId,
            ...selectedEvent,
          },
          getTodaysEvents
        );
        updateTermsAcceptance(result);
      }
    );
  };

  const handleGoToMyAccount = () => {
    if (!hasAccount) {
      push("/register");
    } else {
      push("/myaccount");
    }
    setCompleteRegistrationModal(!completeRegistrationModal);
  };

  const checkBlackFlag = async () => {
    if (!user_ID) {
      return false;
    }
    const response = await getBlackFlagStatus({ user_ID: user_ID });
    if (response && response.payload.isBlackFlag) {
      setBlackFlagError(response.payload.message);
      setShowWarningModal(true);
      return true;
    }
    setBlackFlagError("");
    return false;
  };

  return (
    <React.Fragment>
      <OnlineBiddingRegistrationModal
        isOpen={showBiddingRegistrationModal}
        toggle={() => setShowBiddingRegistrationModal(false)}
      />
      <CommonModal
        title="Error Registering For Event"
        isOpen={showWarningModal}
        toggle={() => setShowWarningModal(!showWarningModal)}
      >
        <div>{blackFlagError}</div>
      </CommonModal>
      <AccountSelectionModal
        isOpen={showAccountSelectionModal}
        toggle={() => setShowAccountSelectionModal(false)}
        accounts={accounts}
        selectedAccountID={selectedAccountId}
        onAccountSelect={setSelectedAccountId}
        onConfirm={handleAccountSelectionConfirm}
        onAcceptTerms={handleAcceptTermsInModal}
        loading={false}
        hasTerms={requiresTermsAcceptance}
        termsDocument={termsAndConditionsDocument}
      />
      {showTermsAcceptanceModal && (
        <ConfirmationModal
          showModal={showTermsAcceptanceModal}
          turnModal={toggleTermsAcceptanceModal}
          onSubmit={handleTermsAcceptanceClick}
          handleCancelSubmit={() =>
            toggleTermsAcceptanceModal((prevState) => !prevState)
          }
          header={"Accept Event's Terms and Conditions"}
          text={`The Terms and Conditions have changed. Please read the new version and accept to continue or you will not be able to register for the event.`}
          terms={termsAndConditionsDocument}
        />
      )}
      {loginModalOpen && (
        <RegisterForm
          {...{
            passwordRequest,
          }}
          isNavEvent={true}
          toggle={() => setLoginModal(!loginModalOpen)}
          isOpen={loginModalOpen}
        />
      )}
      {completeRegistrationModal && (
        <RegisterCompleteModal
          header={"Complete Registration"}
          children={
            <h3>To register for events please complete your registration</h3>
          }
          footer={
            <Button
              style={{ width: "100%" }}
              onClick={() => handleGoToMyAccount()}
              className="btn btn-blue"
            >
              Go to my account
            </Button>
          }
          toggle={() =>
            setCompleteRegistrationModal(!completeRegistrationModal)
          }
          isOpen={completeRegistrationModal}
        />
      )}
      <section className="position-relative home-page-container">
        {content && content.theme.heroImage ? (
          <div
            className="header-container"
            style={{ backgroundImage: `url(${content.theme.heroImage})` }}
          ></div>
        ) : (
          <div className="header-container"></div>
        )}
        <Tabs
          {...{
            clearFilters,
            getInventorySearchCriteria,
            checkForCriteriaKeys,
            content,
          }}
        />
      </section>
      {!retailMode && (
        <React.Fragment>
          <section>
            <Container>
              <Row>
                {todaysEventsLoaded && todaysEvents.length > 0 && (
                  <TodaysEvents
                    handleRegisterForEvent={handleRegisterForEvent}
                    selectedEvent={selectedEvent}
                  />
                )}
                {!todaysEventsLoaded && (
                  <Col xs={12} className="py-5">
                    <div className=" loader-spin-10" />
                  </Col>
                )}
              </Row>
            </Container>
          </section>

          {!enableOnlineAuction && auctionBlock.items && auctionBlock.items.length >= 5 && (
            <section className="home">
              <Container>
                <LiveAuctionBanner
                  {...{ isSignedIn, auctionBlock, push, handlePathChoice }}
                />
              </Container>
            </section>
          )}

          <section>
            <UpcommingAuctions
              {...{
                upcoming,
                push,
                loaded_upcoming,
                setFilteredDates,
                setFilteredIDs,
                clearFilters,
                handlePathChoice,
                handleRegisterForEvent: handleRegisterForEvent,
              }}
            />
          </section>

          <section>
            <Cta {...{ handlePathChoice, content }} />
          </section>
        </React.Fragment>
      )}

      {recentlyViewed.length > 1 ? (
        <div className="container">
          <section className="margin-top-25">
            <RecentlyViewed {...{ recentlyViewed, handlePathChoice }} />
          </section>
        </div>
      ) : (
        ""
      )}
      {isPopUpOpen && (
        <LoginRegister
          toggle={() => setIsPopUpOpen(!isPopUpOpen)}
          isOpen={isPopUpOpen}
        />
      )}
      <div className="flex-1"></div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  isSignedIn: state.authorization.status,
  categories: state.main.categories,
  recentlyViewed: state.main.recentlyViewed,
  upcoming: state.main.upcomingEvents,
  loaded_upcoming: state.main.loaded_upcoming,
  history: state.router,
  auctionBlock: state.main.upcomingAuctionBlock,
  content: state.authorization.content,
  location: state.router.location,
  todaysEvents: state.events.todaysEvents,
  isGuest: state.authorization.isGuest,
  todaysEventsLoaded: state.events.todaysEventsLoaded,
  hasAccount: state.userAccount.hasAccount,
  passwordRequest: state.register.passwordRequest,
  retailMode: state.authorization.retailMode,
  onlineBiddingStatus_ID: state.userAccount.onlineBiddingStatus_ID,
  user_ID: state.authorization.user_ID,
  contactInfo: state.userAccount.contactInfo,
  enableOnlineAuction: state.featureFlags.enableOnlineAuction,
});

const mapDispatchToProps = {
  setFilteredItem,
  getRecentItems,
  getUpcomingAuctionsPreview,
  push,
  checkForStringValue,
  getWatchList,
  checkForLiveAuction,
  getAuctionBlock,
  setFilteredDates,
  setFilteredIDs,
  clearFilters,
  getInventorySearchCriteria,
  checkForCriteriaKeys,
  handlePathChoice,
  getUserInformation,
  getUpcomingEventsSorted,
  updateRegisterState,
  getTodaysEvents,
  loadingTodaysEvents,
  registerForAuctions,
  validateTermsAcceptanceByEventId,
  updateUserTermsAcceptance,
  updateTermsAcceptance,
  getBlackFlagStatus,
  getContactInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
